import { useCallback } from "react";

type GateItem = {
  _id?: string;
  date?: string;
  roomNumber?: unknown;
  patientId?: { fullName?: string };
  bookPatientId?: { fullName?: string };
};

/**
 * Status confirm + same-room ongoing conflict gates are disabled for now
 * so staff can change lifecycle status freely (backend also allows any hop).
 */
export function useOngoingStatusGate() {
  const gateStatus = useCallback(
    async (_item: GateItem, _status: string): Promise<boolean> => true,
    []
  );

  /** @deprecated Prefer gateStatus(item, "ongoing") */
  const gateOngoing = useCallback(
    async (item: GateItem): Promise<boolean> => gateStatus(item, "ongoing"),
    [gateStatus]
  );

  return { gateStatus, gateOngoing, ongoingGateModal: null };
}
